import { useEffect } from 'react'
import { useProjectStore } from '@/features/projects/stores/project-store'
import { useEditorStore } from '@/app/state/editor/store'
import { useAuthSessionStore } from '@/features/auth/stores/auth-session-store'
import { getLocalAgentBridge } from './local-agent-bridge-runtime'
import { getLocalAgentNodeClient } from './local-agent-node-client-runtime'
import { registerVideoCutMcpGlobals } from '@/features/assistant/mcp/mcp-server-runtime'

export function LocalAgentBridgeBootstrap() {
  const currentProjectId = useProjectStore((state) => state.currentProject?.id ?? null)
  const currentEditorWorkspace = useEditorStore((state) => state.workspace)
  const authSessionKey = useAuthSessionStore((state) =>
    state.session
      ? `${state.session.user.id}:${state.session.membership.planCode ?? 'free'}`
      : 'guest',
  )

  useEffect(() => {
    const bridge = getLocalAgentBridge()
    const nodeClient = getLocalAgentNodeClient()
    registerVideoCutMcpGlobals()
    const disconnect = bridge.connect()
    nodeClient.start()
    bridge.emitWorkspaceReady()

    return () => {
      nodeClient.stop()
      disconnect()
    }
  }, [])

  useEffect(() => {
    getLocalAgentBridge().emitCurrentProjectChanged()
  }, [currentProjectId, currentEditorWorkspace, authSessionKey])

  return null
}
